export default {
  TOOL_DESCRIPTION:
    'TAP tool can be used to search devices based on different identifiers',
  DDB: 'DDB'
};
